import { render } from "./item2.vue?vue&type=template&id=2f364e32&scoped=true"
const script = {}

import "./item2.vue?vue&type=style&index=0&id=2f364e32&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f364e32"]])

export default __exports__